module.exports = __webpack_public_path__ + "img/60.8e26f60f.png";